import { Button, useAssetRegistry } from "@cca/components";
import { PropsWithChildren } from "react";

export type ActivityPlayerNextButtonProps = {
  disabled?: boolean;
  loading?: boolean;
  onClick: () => void;
} & PropsWithChildren;

export const ActivityPlayerNextButton = ({
  children,
  disabled,
  loading,
  onClick,
}: ActivityPlayerNextButtonProps) => {
  const { validateAll } = useAssetRegistry();

  const handleOnClick = () => {
    if (!validateAll()) return;

    onClick();
  };

  return (
    <Button
      disabled={disabled}
      loading={loading}
      onClick={handleOnClick}
      type="button"
    >
      {children}
    </Button>
  );
};
